function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1 3.3335L6.26 6.84016C6.47911 6.98635 6.7366 7.06436 7 7.06436C7.2634 7.06436 7.52089 6.98635 7.74 6.84016L13 3.3335M2.33333 10.6668H11.6667C12.0203 10.6668 12.3594 10.5264 12.6095 10.2763C12.8595 10.0263 13 9.68712 13 9.3335V2.66683C13 2.31321 12.8595 1.97407 12.6095 1.72402C12.3594 1.47397 12.0203 1.3335 11.6667 1.3335H2.33333C1.97971 1.3335 1.64057 1.47397 1.39052 1.72402C1.14048 1.97407 1 2.31321 1 2.66683V9.3335C1 9.68712 1.14048 10.0263 1.39052 10.2763C1.64057 10.5264 1.97971 10.6668 2.33333 10.6668Z",
  stroke: "#D1D5DB",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgEmailLetterIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailLetterIcon);
export default __webpack_public_path__ + "static/media/email-letter-icon.0eb0a91f.svg";
export { ForwardRef as ReactComponent };